export default function RemodelingTypesElPaso() {
  const remodelingTypes = [
    {
      name: 'Kitchen Remodeling',
      popularity: 'Most Popular',
      timeline: '4-8 weeks',
      image: 'https://public.readdy.ai/ai/img_res/b5a79c1fad3886e03b34612d329713ea.jpg',
      pros: ['Highest ROI of any remodel', 'Improves daily functionality', 'Modern energy-efficient appliances', 'Increases home value', 'Customizable to your needs'],
      cons: ['Temporary loss of kitchen use', 'Requires careful planning', 'Can be disruptive to daily life'],
      description: 'Kitchen remodeling offers the best return on investment and transforms the heart of your home. El Paso homeowners favor open layouts, durable materials, and energy-efficient appliances suited to our climate.'
    },
    {
      name: 'Bathroom Renovation',
      popularity: 'Very Common',
      timeline: '2-4 weeks',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20bathroom%20renovation%20in%20El%20Paso%20residence%2C%20modern%20spa-like%20design%20with%20walk-in%20shower%20and%20frameless%20glass%2C%20double%20vanity%20with%20contemporary%20fixtures%2C%20neutral%20tile%20and%20elegant%20finishes%2C%20bright%20natural%20lighting%2C%20professional%20interior%20photography%20showing%20quality%20bathroom%20remodeling%20and%20upscale%20design&width=600&height=400&seq=remodel-bathroom-elpaso-031&orientation=landscape',
      pros: ['Adds luxury and comfort', 'Water-efficient fixtures save money', 'Improves resale value', 'Quick project timeline', 'Modernizes outdated spaces'],
      cons: ['Plumbing complexity', 'Requires proper ventilation', 'Temporary bathroom loss'],
      description: 'Bathroom renovations create spa-like retreats while improving functionality. Popular upgrades include walk-in showers, modern vanities, and water-efficient fixtures that reduce utility costs in El Paso.'
    },
    {
      name: 'Master Suite Addition',
      popularity: 'Growing Trend',
      timeline: '8-12 weeks',
      image: 'https://readdy.ai/api/search-image?query=Spacious%20master%20suite%20addition%20in%20El%20Paso%20home%2C%20large%20bedroom%20with%20sitting%20area%20and%20modern%20design%2C%20connected%20luxury%20bathroom%20with%20walk-in%20closet%2C%20southwestern%20architectural%20style%20with%20large%20windows%20and%20mountain%20views%2C%20professional%20real%20estate%20photography%20showing%20quality%20home%20addition%20and%20elegant%20interior&width=600&height=400&seq=remodel-mastersuite-elpaso-032&orientation=landscape',
      pros: ['Adds significant square footage', 'Creates private retreat space', 'Increases home value substantially', 'Avoids moving costs', 'Customized to your preferences'],
      cons: ['Higher investment required', 'Longer project timeline', 'Requires permits and engineering'],
      description: 'Master suite additions provide luxury and privacy without relocating. El Paso contractors design additions that match existing architecture while incorporating modern amenities and energy-efficient features.'
    },
    {
      name: 'Open Floor Plan Conversion',
      popularity: 'Increasingly Popular',
      timeline: '6-10 weeks',
      image: 'https://readdy.ai/api/search-image?query=Modern%20open%20floor%20plan%20renovation%20in%20El%20Paso%20home%2C%20spacious%20living%20room%20flowing%20into%20dining%20area%20and%20kitchen%2C%20removed%20walls%20creating%20bright%20airy%20space%2C%20contemporary%20southwestern%20interior%20design%20with%20natural%20light%2C%20professional%20architectural%20photography%20showing%20successful%20open%20concept%20remodel%20and%20modern%20living%20space&width=600&height=400&seq=remodel-openfloor-elpaso-033&orientation=landscape',
      pros: ['Creates spacious feel', 'Improves traffic flow', 'Better for entertaining', 'Increases natural light', 'Modern aesthetic appeal'],
      cons: ['Structural modifications needed', 'May require HVAC adjustments', 'Load-bearing wall considerations'],
      description: 'Open floor plans are highly desired in El Paso homes, creating flowing spaces perfect for family living and entertaining. Experienced contractors handle structural modifications safely while maintaining home integrity.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Popular Remodeling Projects in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Understanding the most common remodeling projects helps you plan your home transformation. Each type offers unique benefits suited to different needs and budgets.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {remodelingTypes.map((type, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={type.image} 
                  alt={`${type.name} in El Paso`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{type.name}</h3>
                    <div className="flex gap-4 text-sm">
                      <span className="text-teal-600 font-medium">{type.popularity}</span>
                      <span className="text-gray-600">Timeline: {type.timeline}</span>
                    </div>
                  </div>
                </div>
                
                <p className="text-sm text-gray-700 mb-4 leading-relaxed">{type.description}</p>
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <i className="ri-check-line text-green-600"></i>
                      Benefits
                    </h4>
                    <ul className="space-y-1">
                      {type.pros.map((pro, i) => (
                        <li key={i} className="text-xs text-gray-600 flex items-start gap-2">
                          <span className="text-green-600 mt-0.5">•</span>
                          {pro}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <i className="ri-information-line text-orange-600"></i>
                      Considerations
                    </h4>
                    <ul className="space-y-1">
                      {type.cons.map((con, i) => (
                        <li key={i} className="text-xs text-gray-600 flex items-start gap-2">
                          <span className="text-orange-600 mt-0.5">•</span>
                          {con}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
